export default __webpack_public_path__ + "static/295183786cd8a138986521d9f388a286.woff";